import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Button, Input, Link, Logo, Text } from '../../ui';
import { auth } from '../../utils/firebase';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [state, setState] = useState<'initial' | 'error' | 'success'>(
    'initial'
  );
  const location = useLocation();
  const { email: emailFromLogin } = location.state || {};

  useEffect(() => {
    if (emailFromLogin) {
      setEmail(emailFromLogin);
    }
  }, [emailFromLogin]);

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    auth
      .sendPasswordResetEmail(email)
      .then(function () {
        setState('success');
      })
      .catch(function (error) {
        setState('error');
        if (error.code === 'auth/user-not-found') {
          setError('There is no account with that email address');
        } else {
          setError(error.message);
        }
      });
  }

  return (
    <Box
      variant="flex.center"
      sx={{
        backgroundColor: 'surfaceGray',
        width: '100vw',
        height: '100vh',
      }}
    >
      <Box sx={{ position: 'fixed', top: 16, left: 16 }}>
        <Logo />
      </Box>
      <Box sx={{ width: 360 }}>
        {(state === 'initial' || state === 'error') && (
          <form onSubmit={handleSubmit}>
            <Text variant="title" mb={3}>
              Forgot your password?
            </Text>
            <Input
              placeholder="Email"
              type="email"
              value={email}
              name="email"
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            {state === 'error' && <Box pt={2}>{error}</Box>}
            <Button mt={3} type="submit">
              Send password reset email
            </Button>

            <Box mt={3} color="caption" sx={{ textAlign: 'center' }}>
              or{' '}
              <Link to="login" style={{ color: 'rgba(0,0,0,.4)' }}>
                login
              </Link>
            </Box>
          </form>
        )}
        {state === 'success' && (
          <>
            <Text variant="title" mb={3}>
              Reset complete. Please check your email.
            </Text>
            <Link
              to="login"
              sx={{
                color: 'blue',
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'block',
              }}
            >
              Login
            </Link>
          </>
        )}
      </Box>
    </Box>
  );
}
